// Centrale SEO-constanten — absolute URL's voor canonical, og:url en og:image.
export const SITE_URL = "https://www.fedortimmerwerken.nl";

export const ogImageDefault = `${SITE_URL}/__l5e/assets-v1/c1a3ce21-80a3-46a0-ad35-f7c734ff4487/og-default.jpg`;
export const ogImageOver = `${SITE_URL}/__l5e/assets-v1/81a4da95-9fc9-46f9-9398-1285499637c2/og-over.jpg`;

// Gedeelde og:image + twitter:image meta-tags (1200x630 JPEG —
// maximale ondersteuning bij social-crawlers zoals WhatsApp en Facebook).
export function ogImageMeta(image: string, alt: string) {
  return [
    { property: "og:image", content: image },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:alt", content: alt },
    { name: "twitter:image", content: image },
  ] as const;
}
